import React from "react";
import { Column, FlexBox, FluidImage, GridContainer, Listbox, ListboxButton, ListboxList, ListboxOption, ListboxPopover, Row, Typography, useId, } from "@vp/swan";
import { OptionPriceDisplay } from "../../../../shared/options-price-display";
import { encodeKey } from "../../helpers";
import { OptionMarkdownText } from "../../../../shared/option-markdown-text";
import { SimpleTitle } from "../../../../shared/simple-title";
import { ListboxPlaceholder } from "./shared/listbox-placeholder";
import Styled from "styled-components";
import { useListboxSelectionHelper } from "../../../../../hooks/use-listbox-selection-helper";
const WideDropdownStyle = Styled.span `
.swan-listbox-full-width .swan-listbox-button {
  align-items: stretch;
  flex-direction: column;
  justify-content: center;
}
`;
const WideListBoxPopoverStyle = Styled.span `  
.swan-listbox-option {
  padding-right: calc(var(--swan-spacing-standard-4) + 2 * 16px);
}
`;
export const WideDropdownSkin = (props) => {
    const { option, onChanged, showIncompatibleChoices, fractionDigits, locale, currency, priceDisplayMode = "differential-unit", hideImages, hideDescriptions, tenant, } = props;
    const hasImages = !hideImages && option.choices.some((c) => !!c.image);
    const { selectedKeys, handleOnSelectionChange } = useListboxSelectionHelper(option.selectedKey, onChanged);
    const titleId = useId();
    return (React.createElement(WideDropdownStyle, null,
        React.createElement(SimpleTitle, { titleId: titleId }),
        React.createElement(Listbox, { selectionMode: "single", fullWidth: true, selectedKeys: selectedKeys, onSelectionChange: handleOnSelectionChange, mb: "6" },
            React.createElement(ListboxButton, { "aria-labelledby": titleId, placeholder: React.createElement(ListboxPlaceholder, null) }),
            React.createElement(ListboxPopover, null,
                React.createElement(WideListBoxPopoverStyle, null,
                    React.createElement(ListboxList, null, option.choices
                        .filter((choice) => showIncompatibleChoices || choice.isCompatible)
                        .map((choice) => (React.createElement(ListboxOption, { key: encodeKey(choice.key), textValue: choice.name, withThumbnail: true, disabled: choice.isOutOfStock },
                        React.createElement(GridContainer, null,
                            React.createElement(Row, null,
                                hasImages && (React.createElement(Column, { span: 3 },
                                    React.createElement(FluidImage, { src: choice.image }))),
                                React.createElement(Column, { span: hasImages ? 9 : 12 },
                                    React.createElement(FlexBox, { justifyContent: "space-between" },
                                        React.createElement(Typography, { fontWeight: "bold" }, choice.name),
                                        React.createElement(OptionPriceDisplay, { tenant: tenant, choice: choice, fractionDigits: fractionDigits, priceDisplayMode: priceDisplayMode, locale: locale, currency: currency, hideZeroPrice: true })),
                                    !hideDescriptions && (React.createElement(OptionMarkdownText, { markdownText: choice.description }))))))))))))));
};
//# sourceMappingURL=wide-dropdown-skin.js.map